import type { OnePager } from '../types';

// External creation site configuration
const EXTERNAL_CREATION_SITE = 'https://creation-site.example.com';

export const externalRouting = {
  /**
   * Routes user to external creation site with blank spec
   */
  createNew(): void {
    const url = new URL(`${EXTERNAL_CREATION_SITE}/create`);
    window.open(url.toString(), '_blank');
  },

  /**
   * Routes user to external creation site with preloaded spec from template
   */
  createFromTemplate(onePager: OnePager): void {
    const url = new URL(`${EXTERNAL_CREATION_SITE}/create`);
    
    // Pass the spec via query parameters
    url.searchParams.set('template', onePager.id);
    url.searchParams.set('title', onePager.title);
    url.searchParams.set('spec', JSON.stringify(onePager.spec));
    
    window.open(url.toString(), '_blank');
  },

  /**
   * Alternative method using POST to external site
   * (Use this if query params become too long)
   */
  createFromTemplatePost(onePager: OnePager): void {
    // Create a form and submit it to external site
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `${EXTERNAL_CREATION_SITE}/create`;
    form.target = '_blank';

    // Add form fields
    const fields = [
      { name: 'template', value: onePager.id },
      { name: 'title', value: onePager.title },
      { name: 'description', value: onePager.description },
      { name: 'spec', value: JSON.stringify(onePager.spec) }
    ];

    fields.forEach(field => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = field.name;
      input.value = field.value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }
};